import * as Tools from "../../../../helpers/Tools";

const useIsVisitToday = () => {
    const getIsVisitToday = (appointmentDetails) => {
        if (appointmentDetails && appointmentDetails?.appointmentDateTime) {
            return Tools.isVisitToday(appointmentDetails?.appointmentDateTime);
        } else {
            return false;
        }
    }

    return {
        getIsVisitToday,
    };
};

export default useIsVisitToday;